// SettingsCard.jsx
import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  useTheme,
  CardActionArea,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function SettingsCard({
  settingKey,
  settingIcon,
  isSelected,
  onClick,
}) {
  const theme = useTheme();

  return (
    <Card
      sx={{
        backgroundColor: theme.palette.success.main,
        borderColor: isSelected
          ? theme.palette.primary.main
          : theme.palette.grey[300],
        borderWidth: isSelected ? "3px" : "1px",
        borderStyle: "solid",
        borderRadius: 2,
        overflow: "hidden",
        cursor: "pointer",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "160px",
        boxShadow: isSelected ? 3 : 1,
        transition: "all 0.3s ease-in-out",
        "&:hover": {
          boxShadow: 5,
        },
      }}
      onClick={onClick}
    >
      <CardActionArea sx={{ height: "100%", width: "100%", padding: "8px" }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexGrow={1}
          height="70%"
          padding={1}
        >
          <FontAwesomeIcon
            icon={settingIcon}
            style={{
              fontSize: "48px",
              color: theme.palette.success.text,
            }}
          />
        </Box>
        <CardContent
          sx={{
            padding: "4px 8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: theme.palette.background.default,
            textAlign: "center",
            height: "30%",
          }}
        >
          <Typography
            variant="body2"
            textAlign="center"
            color={theme.palette.success.text}
            noWrap
          >
            {settingKey}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default SettingsCard;
